import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CrudService } from '../../../crud/crud.service';
import { NotificationsService } from 'angular2-notifications';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
@Component({
  selector: 'app-devolucion',
  templateUrl: './devolucion.component.html'
})

export class DevolucionComponent implements OnInit{
  dato: FormGroup;
  form_pagos: any;
  form_movimientos_articulos: any;
  cargando = false;
  movimientos_articulos;
  codigo_barras_activo = false;
  caja_abierta = false;
  reimprimir = false;
  agregar_pago = false;
  tamano = document.body.clientHeight;

  empresa = localStorage.getItem('empresa');
  sucursal = localStorage.getItem('sucursal');
  public articulos_term: string = `${environment.API_URL}/articulos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${this.sucursal}`;
  tieneid: boolean = false;

  public startValue: string;
  public selected: string;

  url_nuevo = '../../nuevo';

  subtotal = 0;
  descuento = 0;
  iva = 0;
  total = 0;
  total_recibido = 0;
  cambio = 0;

  usuario;
  caja;
  auto = 0;
  ticket;
  error_venta = false;
  venta_ok = false;
  json;

  objeto = {
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 2000
  };

  time_cambio_cantidad_stoc;
  time_pago;
  public options = {
    position: ['top', 'right'],
    timeOut: 5000,
    lastOnBottom: true
  };
  constructor(
    private fb: FormBuilder,
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private notificacion: NotificationsService) { }

  ngOnInit(): void {

    // obtener los datos del usiario logueado almacen y clues
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    this.caja = JSON.parse(localStorage.getItem('caja'));

    if (this.caja != '') {
      this.caja_abierta = true;
    }
    // inicializar el devolucion reactivo
    this.dato = this.fb.group({
      id: [''],
      tipos_movimientos_id: [11],
      personas_id: [''],
      subtotal: [0],
      descuento: [0],
      iva: [0],
      cajas_id: [''],
      total: [0, [Validators.required]],
      temp_total: [''],
      total_recibido: [0, [Validators.required]],
      cambio: [''],
      codigo: [''],
      folio: [''],
      created_at: [''],
      barcode: [''],
      status_movimientos_id: [1],
      comentarios: [''],
      valido: ['', [Validators.required]],
      pagos: this.fb.array([]),
      movimientos_articulos: this.fb.array([]),
      usuarios: this.fb.group({
        id: [''],
        nombre: ['']
      })
    });

    this.selected = '';
    this.startValue = '';
    // variable para crear el array del devolucion reactivo
    this.form_pagos = {
      pagos_targetas: this.fb.group({
        banco: [''],
        folio: ['']
      }),
      tipos_metodos_pagos_id: ['PUE', [Validators.required]],
      tipos_formas_pagos_id: ['01', [Validators.required]],
      importe: [this.dato.controls['temp_total'].value - this.dato.controls['total'].value, [Validators.required]],
      paga_con: ['', [Validators.required]],
      cambio: ['', [Validators.required]],
      comentarios: ['']
    };

    this.form_movimientos_articulos = {
      articulos_id: ['', [Validators.required]],
      cantidad: ['', [Validators.required]],
      precios_unitario: ['', [Validators.required]],
      articulos_precios_id: [],
      importe: ['', [Validators.required]],
      descuento: ['', [Validators.required]],
      precio_con_descuentos: ['', [Validators.required]],
      iva_porcentaje: ['', [Validators.required]],
      iva_cantidad: ['', [Validators.required]],
      subtotal: ['', [Validators.required]]
    };
    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById('catalogos').click();

    this.dato.controls.personas_id.valueChanges.
      subscribe(val => {
        setTimeout(() => {
          this.dato.controls.tipos_movimientos_id.patchValue(11);
          this.calcular_importe_articulo();
        }, 500);
      });
  }

  cambio_cantidad_stock(articulos, stocks, pos = null) {
    let devolucion = 0;
    if (stocks[pos]['controls'].cantidad_devolucion.value > stocks[pos]['controls'].cantidad.value) {
      stocks[pos]['controls'].cantidad_devolucion.patchValue(stocks[pos]['controls'].cantidad.value);
    }
    stocks.forEach(element => {
      if (element.controls.cantidad_devolucion.value){
        devolucion += parseFloat(element.controls.cantidad_devolucion.value);
      }
    });
    articulos.cantidad_devolucion.patchValue(devolucion);

    this.calcular_importe_articulo();
  }

  cambio_cantidad_stock_key(event, articulos, stocks, pos) {
    if (event.key != 'ArrowLeft'
      && event.key != 'ArrowRight'
      && event.key != 'ArrowUp'
      && event.key != 'ArrowDown'
      && event.key != '.') {
      clearTimeout(this.time_cambio_cantidad_stoc);
      this.time_cambio_cantidad_stoc = setTimeout(() => {
        this.cambio_cantidad_stock(articulos, stocks, pos);
      }, 500);
    }
  }

  calcular_importe_articulo() {
       // sumamos las cantidades
    let total = 0; let c = 0; let restante = 0; let descuento = 0;

    this.dato.get('movimientos_articulos').value.forEach(element => {
      let importe_desc = (element.cantidad - element.cantidad_devolucion) * element.precio_unitario;
      element.importe = (element.cantidad - element.cantidad_devolucion) * element.precio_unitario;
      if (element.descuento > 0) {
        let desc = element.descuento / 100;
        element.precio_con_descuentos = importe_desc - (importe_desc * desc);
        descuento += importe_desc * desc;
      }

      total = total + ((element.cantidad - element.cantidad_devolucion ) * element.precio_unitario);
      const ma = <FormArray>this.dato.controls.movimientos_articulos;
      const it = <FormGroup>ma.controls[c];
      it.controls.importe.patchValue(element.importe);
      it.controls.precio_con_descuentos.patchValue(element.precio_con_descuentos);
      c++;
      if (element.cantidad_restante != 0 && it.controls.stocks['controls'].length > 0) {
        restante++;
      }
    });

    let importe = 0;
    let cambio = 0;
    let i = 0;
    const pagos = <FormArray>this.dato.controls['pagos'];
    this.dato.get('pagos').value.forEach(element => {
      importe = importe + element.paga_con;
    });

    this.dato.controls['subtotal'].patchValue(total);
    this.dato.controls['descuento'].patchValue(descuento);
    this.dato.controls['total'].patchValue(total - descuento);
    this.dato.controls['total_recibido'].patchValue(importe);
    this.dato.controls['cambio'].patchValue(importe - (total - descuento));

    if (this.json) {
      this.json.subtotal = (total);
      this.json.descuento = descuento;
      this.json.total = (total - descuento);
      this.json.total_recibido = (importe);
      this.json.cambio = (importe - (total - descuento));
    }

    if (importe >= (total - descuento)) {
      this.dato.controls['valido'].patchValue('si');

      if (restante > 0) {
        this.dato.controls['valido'].patchValue('');
        this.notificacion.alert('Cantidad surtida', 'Verifique que las cantidades coincidan con lo solicitado: ', this.objeto);
      }
    } else {
      this.dato.controls['valido'].patchValue('');
    }

    const imp = <FormGroup>pagos.controls[pagos.controls.length - 1];
    if (imp) {
      const pago = <FormArray>this.dato.controls.pagos;
      let p = pago.length - 1;
      if (p > 0) {
        pago.controls[p]['controls']['importe'].patchValue(Math.abs(pago.controls[p - 1]['controls']['cambio'].value));
      } else {
        if (imp.controls.paga_con.value == '') {
          imp.controls.importe.patchValue(total - descuento);
        }
      }
    }
    let cambios = total - descuento; let devolver = 0; let pagos_total = 0;
    this.dato.get('pagos').value.forEach(element => {
      const imp = <FormGroup>pagos.controls[i];
      pagos_total += element.paga_con;
      if (element.paga_con > 0) {
        cambios = element.paga_con - cambios;
      }
      imp.controls['cambio'].patchValue(cambios);
      if (!element.id) {
        devolver += parseFloat(element.paga_con);
      }
      i++;
      cambios = Math.abs(cambios);
    });
    this.dato.get('cambio').patchValue(cambios);
    console.log(devolver, this.dato.get('cambio').value);
    if (devolver > 0 && this.dato.get('cambio').value <= 0) {
      this.dato.controls['valido'].patchValue('si');
      this.agregar_pago = false;
    } else {
      this.dato.controls['valido'].patchValue('');
      this.agregar_pago = true;
    }
  }

  agregar_forma_pago(modelo: FormArray, formulario) {
    (<FormArray>modelo).push(this.fb.group(formulario));
    const pago = <FormArray>this.dato.controls.pagos;
    let p = pago.length - 1;
    if (p > 0) {
      pago.controls[p]['controls']['importe'].patchValue(Math.abs(pago.controls[p - 1]['controls']['cambio'].value));
    }
  }

  validar_cantidad_pago(event, modelo, cantidad, tipo, i) {
    if (event.key != 'Backspace'
      && event.key != 'Delete'
      && event.key != 'ArrowLeft'
      && event.key != 'ArrowRight'
      && event.key != 'ArrowUp'
      && event.key != 'ArrowDown'
      && event.key != '.') {
      clearTimeout(this.time_pago);
      this.time_pago = setTimeout(() => {
        this.validar_pago(event, modelo, cantidad, tipo, i);
      }, 500);
    }
  }
  validar_pago(event, modelo, cantidad, tipo, i) {

    let success = true;
    if (tipo == 'min') {
      if (modelo.value < cantidad) {
        success = false;
      }
    }
    if (tipo == 'max') {
      if (modelo.value > cantidad) {
        success = false;
      }
    }
    if (!success) {
      modelo.patchValue(cantidad);
    }

    this.calcular_importe_articulo();
  }
  reset_form() {
    this.selected = '';
    this.startValue = '';
    this.dato.reset();
    for (let item in this.dato.controls) {
      const ctrl = <FormArray>this.dato.controls[item];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == 'number') {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }
    }
  }

  enviar() {
    this.cargando = true;
    this.json = this.dato.getRawValue();

    this.crudService.crear(this.json, 'venta-devolucion').subscribe(
      resultado => {
        this.enviar_ticket(this.json, resultado);
        this.reset_form();
        this.dato.controls.tipos_movimientos_id.patchValue(11);
        this.dato.controls.status_movimientos_id.patchValue(1);
      },
      error => {
        this.error_venta = true;
        this.cargando = false;
        setTimeout(() => {
          this.error_venta = false;
        }, 2500);
      }
    );
  }

  enviar_ticket(json, resultado) {
    this.cargando = false;
    this.reimprimir = true;
    let esto = this;
    this.venta_ok = true;
    setTimeout(() => {
      this.venta_ok = false;
    }, 3000);
    this.json = resultado.data;
    this.calcular_importe_articulo();
    this.error_venta = false;
    if (JSON.parse(localStorage.getItem('configuracion')).sucursal.recibo) {
      setTimeout(() => {
        esto.imprimir();
        document.getElementById('cargar_datos_actualizar').click();
      }, 200);
    }
    setTimeout(() => {
      this.venta_ok = false;
    }, 1500);
  }

  imprimir() {
    /*let pdf = new jsPDF('p', 'pt', 'letter');
    pdf.setProperties({
      title: 'Ticket',
      subject: 'YOURSOFT',
      author: 'Eliecer Ramirez Esquinca',
      keywords: 'yoursoft, web, mobile, desarrollo, agil',
      creator: 'www.yoursoft.com.mx'
    });
    let elementHandler = {
      '.equis': function (element, renderer) {
        return true;
      }
    };
    pdf.fromHTML($('body')[0], 5, 5, {
      'width': 170,
      'elementHandlers': elementHandler
    });

    pdf.output('dataurlnewwindow')*/
    let html = document.getElementById('imprimir').innerHTML;
    html = '<html lang="es">'
      + ' <head>'
      + ' <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />'
      + ' <meta name="charset" content="UTF-8">'
      + ' <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">'
      + ' <meta name="apple-mobile-web-app-capable" content="yes">'
      + ' <title>PDF</title> <meta name="viewport" content="initial-scale=1" />'
      + ' <link rel="stylesheet" href="https://bulma.io/css/bulma-docs.css?v=201712202318">'
      + ' <style>html { font-size: .8em; font-weight: 900; color: #000000;} body {font-size: .8em; font-weight: 900; color: #000000;} select::-ms-expand {display: none;} table{font-size: .7em}'
      + '.figure-border { border-radius: 5px; box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);'
      + ' min-height: 159px;} .hr{ margin: .85rem 0 !important;} .sellos_sat{ font-size:8.5pt !important;}'
      + '.columns{margin:0px !important} .column{padding: .2em !important}</style>'
      + ' </head>'
      + ' <body>'
      + html
      + ' </body>'
      + ' </html>';
    let iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'printf');

    document.body.appendChild(iframe);

    const mywindow: HTMLIFrameElement = document.getElementById('printf') as HTMLIFrameElement;
      mywindow.contentWindow.document.write(html);
      setTimeout(() => {
        //  lanzar la sentencia imprimir
        mywindow.contentWindow.print();
      }, 500);
      setTimeout(() => {
        //  remover el contenedor de impresión
        document.body.removeChild(iframe);
      }, 2000);
  }
}
